import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export const mvImagesSlider = (): Swiper | null => {
  const el = document.querySelector<HTMLElement>(".p-top-mv-images__container");
  if (!el) return null;

  return new Swiper(el, {
    modules: [EffectFade, Autoplay],
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });
};
